import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedH2hService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getH2H(gameDetailId, player1, player2) {
        const body = this.setBody();
        body.set('gameDetailId', gameDetailId);
        body.set('tennisPlayer1', player1);
        body.set('tennisPlayer2', player2);
        return this.http.post(this.urlService + this.routeAdress.route_h2h_get, body.toString()).pipe(
            map((response: any) => {
                if (!response.registers) return response;
                response.registers.tenistas = response.registers.tenistas?.map((tenistaObj) => {
                    // retorna apenas objeto sem id como key
                    // ex: "5010": {...} ----> {...}
                    const [flatedObject] = Object.values(tenistaObj);
                    return flatedObject;
                });
                response.registers.indicadores = response.registers.indicadores
                    ? Object.values(response.registers.indicadores)
                    : null;
                return response;
            })
        );
    }
}
